class Top_smooth {
  constructor() {}
  public smooth(Jump: any): void {
    let top_smooth = document.querySelector('#page_top')
    top_smooth!.addEventListener('click', function(e) {
      e.preventDefault()
      Jump('html', {
        duration: 1000
      })
    })
  }
}
export default Top_smooth
